import React, { Component } from 'react';
import {
  Link
} from 'react-router-dom';

import './Header.css';

class Header extends Component {
  render() {
    if (false) {
      // TODO: add a responsive menu for mobile.
      return (
        <div className="menu">
          <link href="https://fonts.googleapis.com/icon?family=Material+Icons"
            rel="stylesheet" />
          <i className="material-icons">menu</i>
        </div>
      );
    } else {
      return (
        <div className="menu">
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/edit">Edit</Link></li>
            <li><Link to="/message">Message</Link></li>
            <li><Link to="/logout">Log Out</Link></li>
          </ul>
        </div>
      );
    }
  }
}

export default Header;
